import React from 'react';
import '../../../resources/AdminStandardPage.css';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import ReactPaginate from 'react-paginate';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { strategiesService } from '../../../services/StrategiesService';

class Strategies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledDocument: false,
      newStrategy: {
        title: '',
        document: '',
        add_date:''
      },
      existingStrategies: [],
      deleteStrategy: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };
  }

  componentWillMount() {
    strategiesService
      .getAll()
      .then(response => {
        this.setStrategyState(response);
      })
      .catch(error => {
        console.log(error);
      });
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  setStrategyState = response => {
    let existingStrategies = this.state.existingStrategies;
    existingStrategies = response.strategies;
    this.setState({
      existingStrategies
    });
    let pagination = { ...this.state.pagination };
    pagination = response.pagination;
    this.setState({
      pagination
    });
  };

  handlePageClick = currentPage => {
    strategiesService
      .getAll(currentPage.selected + 1)
      .then(response => {
        this.setStrategyState(response);
      })
      .catch(error => console.log(error));
  };

  updateField = event => {
    const fieldName = event.target.name;
    let newStrategy = { ...this.state.newStrategy };
    newStrategy[fieldName] = event.target.value;

    this.setState({
      newStrategy
    });
  };

  resetForm = () => {
    let newStrategy = { ...this.state.newStrategy };
    newStrategy = {
      title: '',
      document: ''
    };
    this.setState({ newStrategy });
    this.setState({ disabledDocument: false });
  };

  openDeleteDialog = id => {
    let deleteStrategy = { ...this.state.deleteStrategy };
    deleteStrategy = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteStrategy });
  };

  closeDeleteDialog = () => {
    let deleteStrategy = { ...this.state.deleteStrategy };
    deleteStrategy = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteStrategy });
  };

  handleFormSubmit = event => {
    event.preventDefault();

    strategiesService
      .createOrUpdate(this.state.newStrategy)
      .then(response => {
        this.resetForm();

        let existingStrategies = this.state.existingStrategies;

        let index = existingStrategies.findIndex(
          existingStrategy => existingStrategy.id === response.id
        );

        if (index !== -1) {
          existingStrategies[index] = response;
        } else {
          existingStrategies.push(response);
        }

        this.setState({
          existingStrategies
        });

        this._notificationSystem.addNotification({
          message: `Strategia a fost ${
            this.state.newStrategy.id ? 'editata' : 'adaugata'
          } cu success.`,
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la adaugare, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  onDropDocument = documents => {
    let newStrategy = { ...this.state.newStrategy };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newStrategy.document = documents[0];

      self.setState({ newStrategy });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newStrategy = { ...this.state.newStrategy };
    newStrategy.document = null;

    this.setState({ newStrategy });
    this.setState({ disabledDocument: false });
  };

  setStrategyForEdit = strategy => {
    let newStrategy = { ...this.state.newStrategy };
    newStrategy = Object.assign({}, strategy);
    this.setState({ newStrategy });

    if (newStrategy.document && newStrategy.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  handleDelete = () => {
    strategiesService
      .deleteStrategy(this.state.deleteStrategy.deleteId)
      .then(() => {
        let existingStrategies = this.state.existingStrategies.slice();
        existingStrategies = existingStrategies.filter(
          strategy => strategy.id !== this.state.deleteStrategy.deleteId
        );
        this.setState({ existingStrategies });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Strategia a fost stearsa cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la adaugare, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Programe si strategii
          </h3>
          <h1 className="admin-switch-title default-title">Strategii</h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga o strategie</h2>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu strategie*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newStrategy.title}
                  />
                </div>


                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Data strategie*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="date"
                    name="add_date"
                    onChange={this.updateField}
                    value={this.state.newStrategy.add_date}
                  />
                </div>

                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document strategie:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newStrategy.document}
                    documentFilename={this.state.newStrategy.document_filename}
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newStrategy.id
                        ? 'Editează Strategie'
                        : 'Adaugă Strategie'}
                    </button>
                  </div>
                  {Object.values(this.state.newStrategy) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingStrategies &&
            this.state.existingStrategies.length > 0 && (
              <div className="admin-standard-page__existing-items">
                <div className="card">
                  <div className="existing-items">
                    <h2 className="existing-items__title label-title">
                      Strategii existente
                    </h2>
                    <div className="existing-items__content">
                      {this.state.existingStrategies.map(strategy => (
                        <div
                          className="existing-items__content-card"
                          key={strategy.id}
                        >
                          <div className="card-content provisions-title-content">
                            <h3 className="major-provisions-title">
                              {strategy.title}
                            </h3>
                          </div>
                          <div className="existing-items__actions-card">
                            <div
                              className="provisions-title-content"
                              onClick={() => this.setStrategyForEdit(strategy)}
                            >
                              <h4 className="action-title"> Editează</h4>
                            </div>

                            <div
                              className="provisions-title-content"
                              onClick={() => this.openDeleteDialog(strategy.id)}
                            >
                              <h4 className="action-title delete-button">
                                {' '}
                                Șterge
                              </h4>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <DeletePUGCertificates
                      opened={this.state.deleteStrategy.openedDialog}
                      handleClose={this.closeDeleteDialog}
                      handleDelete={this.handleDelete}
                      headline="Sunteti sigur ca doriti sa stergeti aceasta strategie?"
                      aditionalText="Dupa stergere, aceasta strategie nu va mai putea fi recuperata."
                    />
                  </div>
                  {this.state.pagination.last_page > 1 && (
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={this.state.pagination.last_page}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  )}
                </div>
              </div>
            )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default Strategies;
